export type DeliveryDropoff = {
  address: string;
  lat: number;
  lng: number;
  placeId?: string | null;
  distanceKm?: number | null;
  durationMin?: number | null;
};

export function deliveryFieldsFromPending(orderData: {
  fulfillmentType?: string;
  deliveryAddress?: string;
  deliveryLat?: number;
  deliveryLng?: number;
  deliveryPlaceId?: string;
}) {
  if (String(orderData.fulfillmentType || '').toLowerCase() !== 'delivery') {
    return {};
  }
  if (!Number.isFinite(Number(orderData.deliveryLat)) || !Number.isFinite(Number(orderData.deliveryLng))) {
    return {};
  }
  return orderDeliveryPayload('delivery', {
    address: orderData.deliveryAddress || '',
    lat: Number(orderData.deliveryLat),
    lng: Number(orderData.deliveryLng),
    placeId: orderData.deliveryPlaceId,
  });
}

export function orderDeliveryPayload(
  fulfillmentType: string | undefined,
  dropoff: DeliveryDropoff | null | undefined
) {
  if (String(fulfillmentType || '').toLowerCase() !== 'delivery' || !dropoff) {
    return {};
  }
  return {
    delivery_address: dropoff.address,
    delivery_lat: dropoff.lat,
    delivery_lng: dropoff.lng,
    ...(dropoff.placeId ? { delivery_place_id: dropoff.placeId } : {}),
  };
}

export function formatDrivingKm(km?: number | null): string {
  if (km == null || !Number.isFinite(Number(km))) return '';
  return `${Number(km).toFixed(1)} km`;
}

export function formatDeliverySummary(order: {
  fulfillment_type?: string | null;
  delivery_address?: string | null;
  delivery_distance_km?: number | null;
}): string | null {
  if (String(order.fulfillment_type || '').toLowerCase() !== 'delivery') {
    return null;
  }
  const km = formatDrivingKm(order.delivery_distance_km);
  if (order.delivery_address && km) {
    return `${order.delivery_address} · ${km}`;
  }
  if (order.delivery_address) return order.delivery_address;
  if (km) return `Delivery · ${km}`;
  return 'Delivery';
}
